// extracted by mini-css-extract-plugin
export var chevronIcon = "_5f-2";
export var teamName = "_5f-1";
export var teamSwitcherButton = "_5f-0";